var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVueSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_vue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.4,3.925H30L16,28.075,2,3.925H12.71L16,9.525l3.22-5.6Z",
    style: {
      fill: "#41b883"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,3.925l14,24.15L30,3.925H24.4L16,18.415,7.53,3.925Z",
    style: {
      fill: "#41b883"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53,3.925,16,18.485l8.4-14.56H19.22L16,9.525l-3.29-5.6Z",
    style: {
      fill: "#35495e"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVueSvg);
export default __webpack_public_path__ + "static/media/vue-svg.4213133e8c47470bd833af0de63d54df.svg";
export { ForwardRef as ReactComponent };